'use client';

import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

export const DEBUG_VISIBILITY = {
  /** No debug flag at all — nothing debug-related may render. */
  HIDDEN: 'hidden',
  /** Flag on, but this viewer may not see internal ids (prod visitor typing `?debug=true`). */
  UNAUTHORISED: 'unauthorised',
  VISIBLE: 'visible',
} as const;

export type DebugVisibility = (typeof DEBUG_VISIBILITY)[keyof typeof DEBUG_VISIBILITY];

/**
 * Shared gate for the hotel-detail debug overlays.
 *
 * `debugEnabled` is `?debug=true` OR `configValuesApp.debugEnabled`, which is itself
 * `isTelesales` — so telesales sessions see the debug lines on every detail page by design.
 * Each caller decides what `UNAUTHORISED` looks like: the room panel offers a sign-in link,
 * the hero renders nothing rather than putting a login prompt beside the hotel title.
 */
export const useDebugVisibility = (): DebugVisibility => {
  const { commonData, curiosityParams, localization } = usePageWrapperData();

  if (!curiosityParams?.debugEnabled) return DEBUG_VISIBILITY.HIDDEN;

  return curiosityParams.isDev || localization.isTelesales || commonData.authenticated
    ? DEBUG_VISIBILITY.VISIBLE
    : DEBUG_VISIBILITY.UNAUTHORISED;
};
